const sectionItemsGridCss = `
[data-type='section-items-grid'] .swiper-pagination {
  margin-top: 20px;
  position: relative;
}

[data-type='section-items-grid'] .swiper-pagination .swiper-pagination-bullet {
  opacity: 1;
  background-color: var(--pagination-inactive-color, #cccccc);
}

[data-type='section-items-grid'] .swiper-pagination .swiper-pagination-bullet-active {
  background-color: var(--pagination-active-color, #000) !important;
}

[data-type='section-items-grid'] [data-attribute='wrapper-container'] {
  padding: 40px 0;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}

[data-type='section-items-grid'] .wrapper-content .content-head {
  margin-bottom: 20px;
}

[data-type='section-items-grid'] .wrapper-content .list-item .item .wrap-imge {
  margin-bottom: 10px;
}

[data-type='section-items-grid'] .wrapper-content .list-item .item .wrap-imge img {
  display: block !important;
  width: 100%;
  height: auto;
}

@container (max-width: 768px) {
  [data-type='section-items-grid'] [data-attribute='wrapper-container'] {
    padding: 16px 0;
  }
}
`;
export default sectionItemsGridCss;
